<template>
<div class="frozen-card-list table-hook fadeInRight">
    <div class="title-box">
        <span class="m-title">冻结卡列表</span>
        <el-form inline class="hook right themed-form search-form" v-model="form" style="line-height: 40px;">
            <el-form-item label="卡号或短号:">
                <el-input v-model="form.searchParam" placeholder="请输入卡号或短号"  clearable=""></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" class="themed-button" @click="searchData">搜索查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-plus" class="themed-button" @click="importAdd">导入</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-minus" class="themed-button" @click="importDelete">删除</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-download" class="themed-button" @click="exportExcel">导出</el-button>
            </el-form-item>
        </el-form>
    </div>
    <div class="content-box">
        <el-table ref="table" :data="tableData" stripe border :max-height="maxTableHeight">
            <el-table-column label="ID" prop="id" show-overflow-tooltip></el-table-column>
            <el-table-column label="卡号" prop="iccid" show-overflow-tooltip></el-table-column>
            <el-table-column label="短号" prop="shortNo" show-overflow-tooltip></el-table-column>
            <el-table-column label="创建时间" prop="createTime" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="150px">
                <template slot-scope="scope">
                    <el-button type="info" class="themed-button" @click="deleteById(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 50, 100, 1000]"
            :page-size="pageSize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialogBox" width="500px" v-if="dialogBox">
        <div v-if="dialogContent === 'import'">
            <el-form label-position="left" label-width="120px">
                <el-form-item label="选择excel文件:" required>
                    <el-upload
                        class="upload-demo"
                        action=""
                        :auto-upload="false"
                        :on-change="handleFileChange"
                        :file-list="fileList"
                        ref="importFile">
                        <el-button slot="trigger" size="small" type="primary" class="themed-button">选择文件</el-button>
                        <span class="file-tip">未选择文件</span>
                    </el-upload>
                    <div class="file-format-tip">仅支持 xls/xlsx格式</div>
                </el-form-item>
                <el-form-item label="ICCID/短号:">
                    <el-input
                        type="textarea"
                        :rows="6"
                        placeholder="请输入ICCID/短号，每行一个"
                        v-model="textInput">
                    </el-input>
                </el-form-item>
            </el-form>
            <div class="dialog-footer">
                <el-button type="primary" class="themed-button"   @click="handleImport">确认</el-button>
                <el-button type="primary"   class="themed-button"   @click="exportTemplate">导出excel模板</el-button>
                <el-button @click="dialogBox = false" type="primary"  class="themed-button" >取消</el-button>
            </div>
        </div>
        <div v-if="dialogContent === 'delete'">
            <el-form label-position="left" label-width="120px">
                <el-form-item label="选择excel文件:" required>
                    <el-upload
                        class="upload-demo"
                        action=""
                        :auto-upload="false"
                        :on-change="handleFileChange"
                        :file-list="fileList"
                        ref="deleteFile">
                        <el-button slot="trigger" size="small" type="primary" class="themed-button">选择文件</el-button>
                        <span class="file-tip">未选择文件</span>
                    </el-upload>
                    <div class="file-format-tip">仅支持 xls/xlsx格式</div>
                </el-form-item>
                <el-form-item label="ICCID/短号:">
                    <el-input
                        type="textarea"
                        :rows="6"
                        placeholder="请输入ICCID/短号，每行一个"
                        v-model="textInput">
                    </el-input>
                </el-form-item>
            </el-form>
            <div class="dialog-footer">
                <el-button type="primary" @click="handleDelete"  class="themed-button">确认</el-button>
                <el-button type="primary" @click="exportDeleteTemplate"  class="themed-button">导出excel模板</el-button>
                <el-button @click="dialogBox = false" type="primary"   class="themed-button">取消</el-button>
            </div>
        </div>
    </el-dialog>
</div>
</template>

<script>
import { listFrozenCard, batchImportSync, batchDeleteSync, deleteById, exportFrozenCard } from '@/api/cardManagement/frozenCardList.js'
import { messageBox, confirmBox } from '@/utils/common.js'
import resize from '@/mixins/resize.js'
import Utils from '@/utils/utils.js'
import {exportTemplate} from '@/api/statistics.js'

export default {
    mixins: [resize],
    data() {
        return {
            form: {
                searchParam: ''
            },
            tableData: [],
            pageSize: 15,
            currentPage: 1,
            total: 0,

            dialogBox: false,
            dialogTitle: '',
            dialogContent: '',
            importType: 'excel',
            deleteType: 'excel',
            fileList: [],
            textInput: '',
            uploadFile: null
        }
    },
    mounted() {
        this.getFrozenCardList()
    },
    methods: {
        importAdd() {
            this.dialogTitle = '导入冻结卡'
            this.dialogContent = 'import'
            this.dialogBox = true
            this.fileList = []
            this.textInput = ''
        },
        importDelete() {
            this.dialogTitle = '删除冻结卡'
            this.dialogContent = 'delete'
            this.dialogBox = true
            this.fileList = []
            this.textInput = ''
        },
        handleFileChange(file) {
            this.uploadFile = file.raw
            this.fileList = [file]
        },
        handleImport() {
            let formData = new FormData();
            
            // 处理卡信息
            if (!this.uploadFile && !this.textInput.trim()) {
                messageBox(this, '请选择文件或输入卡号信息')
                return
            }
            
            // 如果有文件，检查文件格式并添加到表单
            if (this.uploadFile) {
                let fileName = this.uploadFile.name;
                let index = fileName.lastIndexOf(".");
                if (index < 0 || !(fileName.substring(index + 1, fileName.length) == 'xls' || fileName.substring(index + 1, fileName.length) == 'xlsx')) {
                    messageBox(this, '文件格式错误')
                    return
                }
                formData.append('fileurl', this.uploadFile);
            }
            
            // 无论是否有文件，都添加卡信息到表单
            formData.append('cards', this.textInput);
            
            batchImportSync(formData).then(res => {
                if (res.system_result_key == '0') {
                    if (this.uploadFile) {
                        this.$alert(res.system_result_message_key || '导入成功，请到导入记录中下载', '提示', {
                            confirmButtonText: '确定',
                        }).then(() => {
                            this.uploadFile = null;
                            this.fileList = [];
                            this.textInput = '';
                            this.dialogBox = false;
                            this.$router.push('/tob/i_import_list');
                        })
                    } else {
                        this.$message.success(res.system_result_message_key || '导入成功');
                        this.textInput = '';
                        this.dialogBox = false;
                        this.getFrozenCardList();
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: 'error'
                    })
                }
            })
        },
        handleDelete() {
            let formData = new FormData();
            
            // 处理卡信息
            if (!this.uploadFile && !this.textInput.trim()) {
                messageBox(this, '请选择文件或输入卡号信息')
                return
            }
            
            // 如果有文件，检查文件格式并添加到表单
            if (this.uploadFile) {
                let fileName = this.uploadFile.name;
                let index = fileName.lastIndexOf(".");
                if (index < 0 || !(fileName.substring(index + 1, fileName.length) == 'xls' || fileName.substring(index + 1, fileName.length) == 'xlsx')) {
                    messageBox(this, '文件格式错误')
                    return
                }
                formData.append('fileurl', this.uploadFile);
            }
            
            // 无论是否有文件，都添加卡信息到表单
            formData.append('cards', this.textInput);
            
            batchDeleteSync(formData).then(res => {
                if (res.system_result_key == '0') {
                    this.$alert(res.system_result_message_key || '删除成功', '提示', {
                        confirmButtonText: '确定',
                    }).then(() => {
                        this.uploadFile = null;
                        this.fileList = [];
                        this.textInput = '';
                        this.dialogBox = false;
                        this.getFrozenCardList();
                    })
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: 'error'
                    })
                }
            })
        },
        deleteById(row) {
            confirmBox(this, `是否确认删除该冻结卡？`, '操作提示', () => {
                deleteById({ id: row.id }).then(res => {
                    messageBox(this, '删除成功')
                    this.getFrozenCardList()
                })
            })
        },
        searchData() {
            this.currentPage = 1
            this.getFrozenCardList()
        },
        exportExcel() {
            exportFrozenCard(this.form).then((res) => {
                if (
                    res.system_result_key == '0' ||
                    res.app_result_key == '0'
                ) {
                    this.$alert('导出成功，请到导出记录中下载', '提示', {
                        confirmButtonText: '确定',
                    }).then(() => {
                        this.$router.push('/tob/i_export_list')
                    })
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key || '导出提交失败',
                        type: 'error',
                    })
                }
            })
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.getFrozenCardList()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getFrozenCardList()
        },
        getFrozenCardList() {
            const params = {
                pageSize: this.pageSize,
                pageNo: this.currentPage,
                ...this.form
            }
            listFrozenCard(params).then(res => {
                console.log(res)
                if (res && res.data) {
                    this.total = res.data.total || 0
                    this.tableData = res.data.rows || []
                } else if (res && res.page) {
                    this.total = res.page.total || 0
                    this.tableData = res.page.rows || []
                } else {
                    this.total = 0
                    this.tableData = []
                }
            }).catch(error => {
                console.error('获取列表失败:', error)
                this.total = 0
                this.tableData = []
            })
        },
        // 导出模板
        exportTemplate() {
            exportTemplate({name: 'importIccidOrShort.xls'}).then(res => {
                const filename = 'importIccidOrShort.xls'
                Utils.createDownload(res, filename)
            })
        },
        // 导出删除模板
        exportDeleteTemplate() {
            exportTemplate({name: 'importIccidOrShort.xls'}).then(res => {
                const filename = 'importIccidOrShort.xls'
                Utils.createDownload(res, filename)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.frozen-card-list {
    padding: 20px;
    
    .title-box {
        margin-bottom: 20px;
        
        .m-title {
            font-size: 18px;
            font-weight: bold;
        }
    }
    
    .content-box {
        margin-bottom: 20px;
    }
    
    .pagination {
        text-align: right;
    }

    .dialog-footer {
        text-align: center;
        margin-top: 20px;
    }

    .file-format-tip {
        font-size: 12px;
        color: #999;
        margin-top: 5px;
    }

    .file-tip {
        margin-left: 10px;
        color: #666;
    }

    .upload-demo {
        display: inline-block;
    }

    :deep(.el-upload-list) {
        display: none;
    }

    :deep(.el-form-item__label) {
        font-weight: normal;
    }
}
</style> 